import { HttpMethodEnum, HttpResponse } from '@ipevo-rd/service-web-utils'
import { ShortUrlReq } from './dto/ShortUrlDTO.js'
import { v1HttpClient } from './index.js'

/**
 * ShortUrl
 */
export const ShortUrl = {
	/**
	 * 取得短網址原始網址
	 * @param params {ShortUrlReq} 參數
	 * @return {Promise<HttpResponse>}
	 */
	getOriginalURL: (params: ShortUrlReq): Promise<HttpResponse> =>
		v1HttpClient.request({
			url: `/s/${params.url}`,
			method: HttpMethodEnum.GET,
		}),
}
